import type { ComingSoonContent } from "./types";

export const comingSoonContent: ComingSoonContent = {
  heading: "Coming Soon",
  intro:
    "What we're building next. This is direction, not a promise — priorities shift as we learn.",
  items: [
    {
      title: "Play together",
      description:
        "Shared campaigns for a full party, not just one player at a time.",
    },
    {
      title: "More subclasses and deeper character options",
      description:
        "Broader per-class, per-subclass, and multiclass content as character-building keeps growing.",
    },
    {
      title: "A growing bestiary",
      description: "More monsters, with richer signature abilities.",
    },
    {
      title: "More magic items",
      description:
        "A fuller magic-item catalogue, including attunement and rarity.",
    },
    {
      title: "Downtime between sessions",
      description:
        "Rests, travel time, and the passage of time handled properly, not just combat rounds.",
    },
    {
      title: "Richer environments",
      description:
        "Weather, better lighting and obscurement, more terrain effects.",
    },
    {
      title: "A dedicated GM prep space",
      description:
        "Build out zones, NPCs, and encounters ahead of your session, with suggestions you review and approve before anything lands in the world.",
    },
  ],
  metaTitle: "Coming Soon — Verderem",
  metaDescription:
    "What we're building next for Verderem — more content, more rulesets, and deeper tools for players and GMs alike.",
};
